import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo.png'
import _imports_1 from '@/assets/img/eng.png'
import _imports_2 from '@/assets/img/arrow_right.svg'
import _imports_3 from '@/assets/img/thai.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-3a893eeb")

_pushScopeId("data-v-3a893eeb")
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "logoWrapper" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "logo"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("a", { href: "/" }, "main", -1)
const _hoisted_6 = { class: "inner" }
const _hoisted_7 = { class: "menuTitleSm" }
const _hoisted_8 = { class: "langBlock sm" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "in" }
const _hoisted_11 = { class: "in" }
const _hoisted_12 = { href: "/" }
const _hoisted_13 = { class: "right" }
const _hoisted_14 = { class: "head" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("span", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("header", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", {
            class: ["siteLogo", [_ctx.theme === 'light' ? ['light'] : '']]
          }, [
            _hoisted_4,
            _createVNode("span", null, _toDisplayString(_ctx.t("header.logo")), 1),
            _hoisted_5
          ], 2)
        ]),
        _createVNode("div", {
          class: "menuWrapper menuSm",
          style: { display: _ctx.computedDisplayMenu, opacity: _ctx.computedOpacityMenu }
        }, [
          _createVNode("div", _hoisted_6, [
            _createVNode("span", {
              class: "icon-close close closeMenuBtn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openCloseMenu()))
            }),
            _createVNode("span", _hoisted_7, _toDisplayString(_ctx.t("header.menu")), 1),
            _createVNode("nav", null, [
              _createVNode("ul", {
                class: ["menuList", [_ctx.theme === 'light' ? ['light'] : '']]
              }, [
                _createVNode("li", null, [
                  _createVNode(_component_router_link, { to: { path: '/product' } }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("header.nav.product")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("li", null, [
                  _createVNode(_component_router_link, { to: { path: '/pricing' } }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("header.nav.pricing")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("li", null, [
                  _createVNode(_component_router_link, { to: { path: '/contact-us' } }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("header.nav.contact-us")), 1)
                    ]),
                    _: 1
                  })
                ])
              ], 2),
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, _toDisplayString(_ctx.t("header.nav.language.title")), 1),
                _createVNode("div", {
                  class: _ctx.arrowClicked === true ? 'head active' : 'head'
                }, [
                  _createVNode("div", _hoisted_10, [
                    _createVNode("img", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setLocale('en'))),
                      src: _imports_1,
                      alt: "eng",
                      class: "lang"
                    }),
                    _createVNode("span", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setLocale('en'))),
                      class: "text"
                    }, _toDisplayString(_ctx.t("header.nav.language.eng")), 1),
                    _createVNode("img", {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showSecondLangBlock())),
                      src: _imports_2,
                      alt: "arrow",
                      class: "arr"
                    })
                  ])
                ], 2),
                _createVNode("div", {
                  class: ["list", { showSecondLangBlockCSS: _ctx.arrowClicked }]
                }, [
                  _createVNode("div", _hoisted_11, [
                    _createVNode("a", _hoisted_12, [
                      _createVNode("img", {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setLocale('th'))),
                        src: _imports_3,
                        alt: "thai",
                        class: "lang",
                        height: "23"
                      }),
                      _createVNode("span", {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setLocale('th'))),
                        class: "text"
                      }, _toDisplayString(_ctx.t("header.nav.language.thai")), 1)
                    ])
                  ])
                ], 2)
              ])
            ])
          ])
        ], 4)
      ]),
      _createVNode("div", _hoisted_13, [
        _createVNode("div", {
          class: "langBlock",
          onMouseleave: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.leavemouse && _ctx.leavemouse(...args)))
        }, [
          _createVNode("div", _hoisted_14, [
            _createVNode("div", null, [
              (_ctx.currentLang === 'en')
                ? (_openBlock(), _createBlock("img", {
                    key: 0,
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setLocale('th'))),
                    src: _imports_3,
                    alt: "eng",
                    class: "lang"
                  }))
                : _createCommentVNode("", true),
              (_ctx.currentLang === 'th')
                ? (_openBlock(), _createBlock("img", {
                    key: 1,
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setLocale('en'))),
                    src: _imports_1,
                    alt: "thai",
                    class: "lang"
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ], 32),
        _createVNode("a", {
          href: _ctx.registerUrl,
          class: "btnFillType7 font-sarabun"
        }, _toDisplayString(_ctx.t("header.register")), 9, ["href"]),
        _createVNode("a", {
          href: _ctx.registerUrl,
          class: "siteLink loginSm"
        }, _toDisplayString(_ctx.t("header.register")), 9, ["href"]),
        _createVNode("a", {
          href: _ctx.loginUrl,
          class: "btnFillType1 font-sarabun"
        }, _toDisplayString(_ctx.t("header.login")), 9, ["href"]),
        _createVNode("a", {
          href: _ctx.loginUrl,
          class: "siteLink loginSm"
        }, _toDisplayString(_ctx.t("header.login")), 9, ["href"]),
        _createVNode("div", {
          class: "openMenuBtn",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.openCloseMenu()))
        }, [
          _hoisted_15,
          _hoisted_16,
          _hoisted_17
        ])
      ])
    ])
  ]))
})